module.exports = __webpack_public_path__ + "img/1e6a313.jpg";